module.exports = __webpack_public_path__ + "img/icon-add-light-blue.d857ca1e.svg";